import { createRouter, createWebHistory } from 'vue-router'
import { routesForCurrentBuild } from './buildRoutes'
import { APP_ROLE } from '@/config/env'
import { useAuthStore } from '@/stores/auth'
import { useInviteRefStore } from '@/entities/referral/model/useInviteRefStore'
import { useUtmStore } from '@/entities/utm/model/useUtmStore'
import { applyRouteTitle } from '@/composables/usePageTitle'
import { handleChunkLoadError } from '@/shared/lib/chunkLoad'

const loginRouteByRole = {
  client: 'client-login',
  courier: 'courier-login',
  restaurant: 'restaurant-login',
  admin: 'admin-login',
}

const homeByRole = {
  client: 'client-home',
  courier: 'courier-home',
  restaurant: 'restaurant-home',
  admin: 'admin-orders',
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routesForCurrentBuild(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, left: 0 }
  },
})

router.beforeEach((to) => {
  if (APP_ROLE === 'client') {
    if (to.query.ref != null) {
      useInviteRefStore().captureFromQuery(to.query)
    }
    useUtmStore().captureFromQuery(to.query)
  }

  if (!to.meta.requiresAuth) {
    return true
  }

  const authStore = useAuthStore()
  if (!authStore.isLoggedIn) {
    return {
      name: loginRouteByRole[APP_ROLE] ?? 'client-login',
      query: { redirect: to.fullPath },
    }
  }

  if (APP_ROLE === 'admin') {
    const requiredCodes = to.meta.accessCodes
    if (Array.isArray(requiredCodes) && requiredCodes.length) {
      if (!authStore.hasAnyAccessCode(requiredCodes)) {
        const fallback = authStore.defaultAdminRouteName
        if (fallback && fallback !== to.name) {
          return { name: fallback }
        }
        return { name: 'admin-profile' }
      }
    }
  }

  return true
})

router.afterEach((to) => {
  applyRouteTitle(to)
})

router.onError((error) => {
  handleChunkLoadError(error, () => {
    router.replace({ name: homeByRole[APP_ROLE] || 'client-home' }).catch(() => {})
  })
})

export default router
